/* TODO: t() */
import React, { useMemo, useState } from 'react';

import {
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Table,
  Tbody,
  Td,
  Tr,
} from '../../core-ui';

import { VendorSummaryWithMarkets } from '../../types/shared/Vendor';

type Props = {
  isOpen: boolean;
  onClick: (vendor: VendorSummaryWithMarkets | null) => void;
  onClose: () => void;
  placedVendors: ObjectOf<boolean>;
  vendors: Array<VendorSummaryWithMarkets>;
};

export function VendorSelectModal(props: Props) {
  let { isOpen, onClick, onClose, placedVendors, vendors } = props;
  const [searchValue, setSearchValue] = useState('');

  const filteredVendors = useMemo(() => filterVendors(vendors, searchValue), [
    searchValue,
    vendors,
  ]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Assign a vendor</ModalHeader>
        <ModalCloseButton />
        <ModalBody alignItems="center" px={4}>
          <Input
            value={searchValue}
            placeholder="Search..."
            onChange={(event) => {
              setSearchValue(event.target.value);
            }}
          />
          <Table p={2}>
            <Tbody>
              <Tr onClick={() => onClick(null)}>
                <Td>( none )</Td>
              </Tr>
              {filteredVendors.map((vendor, i) => {
                return (
                  <Tr
                    key={i}
                    color={placedVendors[vendor.id] ? 'grey' : 'black'}
                    onClick={() => {
                      onClick(vendor);
                      onClose();
                    }}
                  >
                    <Td>{vendor.name}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function vendorSearchMatches(
  vendor: VendorSummaryWithMarkets,
  searchText: string,
) {
  if (searchText === '') {
    return true;
  }
  for (let key of ['email', 'id', 'name'] as const) {
    let value = typeof vendor[key] === 'string' ? vendor[key] ?? '' : '';
    if (value.toLowerCase().includes(searchText)) {
      return true;
    }
  }
  return false;
}

function filterVendors(
  vendors: Array<VendorSummaryWithMarkets>,
  searchValue: string,
) {
  let searchText = searchValue.toLowerCase().trim();
  return vendors.filter((vendor) => vendorSearchMatches(vendor, searchText));
}
